import React from 'react'
import './awurudu.css';



function AwuruduSeason() {
  return (
    <div className="sun-overlay">
    <div className="sun-container">
      <img src="/awurudu/sun.png" alt="Sun with New Year" className="sun" />
    </div>
  </div>
  )
}

export default AwuruduSeason;